export default __webpack_public_path__ + "media/images/images/banner/banner-19-0be695ecd66906a883579a6dee7dd54f.jpg";